import { Table } from "antd"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react";
import { getSessionItem, setSessionItem } from "../../utils/storageUtils";
import { TBL_PAGE_SIZE } from "../../utils/Constants";
import { setContentLoading, setPageFromIndex } from "../../store/reducers/CommonReducer"
import { formatDictString, getTranslated } from "../../utils/CommonUtils";

const UMCTable = (props) => {

  const dynamicDataItemCount = useSelector(state => state.common.dynamicPagnItemCount)
  const pageFromIndex = useSelector(state => state.common.pageFromIndex)
  const [pageSize, setPageSize] = useState(getSessionItem(TBL_PAGE_SIZE) || 50)
  const [currentPage, setCurrentPage] = useState(1)
  const [previousPageSizeRef, setPreviousPageSizeRef] = useState(getSessionItem(TBL_PAGE_SIZE) || 50)
  const dict = useSelector(state => state.common.dict)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setPageFromIndex(0))
    if (getSessionItem(TBL_PAGE_SIZE) !== null)
      setPageSize(getSessionItem(TBL_PAGE_SIZE))
    else
      setSessionItem(TBL_PAGE_SIZE, 50)
  }, [])

  const handleMouseEvents = (key, hovered) => {
    props.handleRowHover && props.handleRowHover(hovered ? key : null)
  }

  const handlePageSizechange = (currentPage, pageSize) => {

    setPageSize(pageSize)

    setSessionItem(TBL_PAGE_SIZE, pageSize)
    setCurrentPage(1)
    if (props.isDynamicAction) {
      dispatch(setPageFromIndex(0))
      dispatch(props.fetchData())
    }
  }

  const handlePageChange = (newCurrentPage, newCurrentPagesSize) => {
    console.log(previousPageSizeRef)
    if (newCurrentPagesSize === previousPageSizeRef) { // cheacking if pazesize has been chnaged
      if (newCurrentPage !== currentPage) {  // Avoid unnecessary updates if page didn't change
        setCurrentPage(newCurrentPage)

        if (props.isDynamicAction) {
          dispatch(setPageFromIndex((newCurrentPage - 1) * newCurrentPagesSize))
          dispatch(props.fetchData());
        }
      }
    }
    setPreviousPageSizeRef(newCurrentPagesSize)
  }

  const getTableLocale = () => {
    return {
      triggerAsc: getTranslated(dict, "LABEL_CLICK_SORT_ACS"),
      triggerDesc: getTranslated(dict, "LABEL_CLICK_SORT_DESC"),
      // sortOrderDescriptions: {
      //   ascend: 'Click to sort ascendingg',
      //   descend: 'Click to sort descendingg',
      //   cancel: 'Cancel sortingg',
      // },
    }
  }

  const getPaginationLocale = () => {
    return {
      items_per_page: "/ " + getTranslated(dict, "LABEL_PAGE"), // [10 / Page]
      prev_page: getTranslated(dict, "LABEL_PREV_PAGE"),
      next_page: getTranslated(dict, "LABEL_NEXT")
    }
  }

  return <Table
    className={`table-striped-rows ${props.className}`}
    columns={props.columns}
    dataSource={props.dataSource}
    onChange={props.onChange}
    locale={getTableLocale()}
    size={props.size || "small"}

    rowClassName={(record, index) => {
      return (index === props.rowIndex) ? props.rowActiveClassName : props.rowIdleClassName
    }}

    onRow={(record, rowIndex) => {
      return {
        onMouseEnter: (event) => {
          handleMouseEvents(record.key, true)
        }, // mouse enter row
        onMouseLeave: (event) => {
          handleMouseEvents(record.key, false)
        }, // mouse leave row
        onClick: (event) => {
          event.preventDefault()
          event.stopPropagation()

          if(props.handleRowSelect) {
            dispatch(setContentLoading(true))
            props.handleRowSelect(record)
          }
        }
      }
    }}

    pagination={{
      itemRender: (page, type, originalElement) => {
        return originalElement
      },
      current: (props.isDynamicAction)?((pageFromIndex==0 && currentPage!=1)?setCurrentPage(1):currentPage): currentPage,
      className: "custom-pagn",
      total: (props.isDynamicAction) ? dynamicDataItemCount : props.dataSource?.length,
      responsive: true,
      showSizeChanger: true,
      pageSize: pageSize,
      onShowSizeChange: handlePageSizechange,
      onChange: handlePageChange,
      showTotal: (total, range) => formatDictString(dict, "LABEL_PAGINATION_RANGE", {x: range[0], y: range[1], n: total}),
      locale: getPaginationLocale()
    }}

    scroll={{
      y: props.height,
      x: props.width || 300
    }}

    rowSelection={props.bulk && {
      selectedRowKeys: props.selectedRows,
      type: "checkbox",
      onChange: (selectedRowKeys, selectedRows) => {
        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
        props.handleBulkSelection && props.handleBulkSelection(selectedRowKeys)
      },
      getCheckboxProps: (record) => ({
        disabled: !record.bulk
      }),
    }}
  />
}

export default UMCTable